import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { MainInfoTitleWrapper, MainInfoWrapper } from '../../../components/Paper';
import styled from '../../../config/theme';
import ProductInfoLoadingState from './ProductInfoLoadingState';
import { ProductStatusBadge } from './';

type Props = {
  availabilityId?: string;
  availabilityProductId?: string;
  availabilitySkuId?: string;
  code?: string;
  productIsPending?: boolean;
  priceMethodDescription?: string;
  productDescription?: string;
  productStatusDescription?: string;
  productStatusId?: number;
  productTypeDescription?: string;
};

const ProductInfo: React.FC<Props> = ({
  availabilityId,
  availabilityProductId,
  availabilitySkuId,
  code,
  productIsPending,
  priceMethodDescription,
  productDescription,
  productStatusDescription,
  productStatusId,
  productTypeDescription,
}: Props) => {
  const { t } = useTranslation('products');
  const hasAvailabilityData = availabilityProductId || availabilitySkuId || availabilityId;

  return (
    <ProductInfoWrapper data-cy="product-general-info">
      {!code || productIsPending ? (
        <ProductInfoLoadingState />
      ) : (
        <ProductInfoTitleWrapper>
          <h1>{productDescription}</h1>
          <h2>{code}</h2>
          <p>{productTypeDescription}</p>
          <BadgeWrapper>
            <ProductStatusBadge text={priceMethodDescription || ''} />
            <ProductStatusBadge id={productStatusId} text={productStatusDescription || ''} />
          </BadgeWrapper>
          {hasAvailabilityData && (
            <AvailabilityWrapper>
              {availabilityProductId && (
                <AvailabilityItem>
                  <AvailabilityLabel>{t('fullView.labels.availabilityProductId')}:</AvailabilityLabel>
                  <span>{availabilityProductId}</span>
                </AvailabilityItem>
              )}
              {availabilitySkuId && (
                <AvailabilityItem>
                  <AvailabilityLabel>{t('fullView.labels.availabilitySkuId')}:</AvailabilityLabel>
                  <span>{availabilitySkuId}</span>
                </AvailabilityItem>
              )}
              {availabilityId && (
                <AvailabilityItem>
                  <AvailabilityLabel>{t('fullView.labels.availabilityId')}:</AvailabilityLabel>
                  <span>{availabilityId}</span>
                </AvailabilityItem>
              )}
            </AvailabilityWrapper>
          )}
        </ProductInfoTitleWrapper>
      )}
    </ProductInfoWrapper>
  );
};

const BadgeWrapper = styled.div`
  display: flex;
`;

const AvailabilityWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-top: 8px;
`;

const AvailabilityItem = styled.div`
  display: flex;
  gap: 6px;
  font-size: 14px;
  color: ${({ theme }) => theme.itemSidebar.color.item.subText};
`;

const AvailabilityLabel = styled.span`
  font-weight: 600;
  white-space: nowrap;
`;

const ProductInfoTitleWrapper = styled(MainInfoTitleWrapper)`
  flex-direction: column;
`;

const ProductInfoWrapper = styled(MainInfoWrapper)`
  padding: 0;
  flex-direction: column;
  justify-content: space-between;
`;

export default ProductInfo;
